/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDoctor = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 2a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm0 2c.888 0 1.687.386 2.236 1H9.764c.55-.614 1.348-1 2.236-1zm0 6a3 3 0 0 1-3-3h2a1 1 0 1 0 2 0h2a3 3 0 0 1-3 3zM5 21c0-1.417.48-2.616 1.502-3.48a5.09 5.09 0 0 1 .998-.65V22h2v-5.783A13.257 13.257 0 0 1 12 16c.537 0 1.037.025 1.5.072v2.976c-.19.083-.382.193-.562.338-.565.452-.938 1.164-.938 2.114v.5h2v-.5c0-.206.038-.33.071-.402a.403.403 0 0 1 .116-.15c.104-.083.246-.115.313-.115s.21.032.313.114a.416.416 0 0 1 .116.151.948.948 0 0 1 .071.402v.5h2v-.5c0-.95-.373-1.662-.938-2.114a2.494 2.494 0 0 0-.562-.338v-2.58c.844.267 1.5.632 1.998 1.053C18.52 18.384 19 19.584 19 21v1h2v-1c0-1.9-.664-3.7-2.212-5.008C17.261 14.703 15 14 12 14c-3 0-5.261.704-6.788 1.992C3.664 17.3 3 19.1 3 21v1h2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDoctor as Doctor };
